import React from 'react';

import { Card } from '@travauxlib/shared/src/components/DesignSystem/components/Card';
import { Tag } from '@travauxlib/shared/src/components/DesignSystem/components/Tag';

type Props = {
  title: string;
  subTitle?: string | React.ReactElement;
  secondSubTitle?: string | React.ReactElement;
  children: React.ReactNode;
  timeData?: 'month' | 'week';
};

const getTraduction = (timeData: 'month' | 'week'): string =>
  timeData === 'month' ? 'Mois' : 'Semaine';
export const DataCard: React.FC<Props> = ({
  title,
  children,
  timeData,
  subTitle,
  secondSubTitle,
}) => (
  <Card className=" w-full sm-desktop:w-[15rem] md-desktop:w-[18rem] lg-desktop:w-[25rem]">
    {timeData && (
      <div className="flex justify-end">
        <Tag
          size="md"
          variant={timeData === 'week' ? 'warning' : 'info'}
          label={getTraduction(timeData)}
        />
      </div>
    )}
    <div className="flex flex-col gap-xs justify-center items-center text-center md-desktop:mt-sm">
      <div className="text-h3 lg-desktop:text-h2 font-semibold">{title}</div>
      <div className="text-b2 text-secondary space-y-xxs">
        {subTitle && <div>{subTitle}</div>}
        {secondSubTitle && <div>{secondSubTitle}</div>}
      </div>
      <div>{children}</div>
    </div>
  </Card>
);
